// var jcf = require("jcf");

// jcf.setOptions('Select', {
// 	"wrapNative": false,
// 	"flipDropToFit": false,
// 	"maxVisibleItems": 10
// });
// jcf.setOptions('Radio', {
// 	"wrapNative": true,
// 	"checkedClass": "checked",
// 	"labelActiveClass": "active"
// });

// jcf.replace('select.multi-site-dropdown');
// // jcf.replace('textarea');
// jcf.replace('.site-content input[type="checkbox"]');
// jcf.replace('.site-content input[type="file"]');
// jcf.replace('.site-content input[type="number"]');
// jcf.replace('.site-content input[type="radio"]');
// jcf.replace('.site-content input[type="file"]');
// jcf.replace('.site-content input[type="range"]');
// jcf.replace('.site-content .jcf-scrollable');

// jcf.replace('.site-content select');
// jcf.replace('.site-content .wpcf7-select');
// jcf.replace('.site-content .facetwp-dropdown');

function customforms_checkbox() {
	const checkboxes = document.querySelectorAll('input[type="checkbox"]');
	checkboxes.forEach((checkbox) => {
		const label = document.createElement('label');
		checkbox.parentNode.insertBefore(label, checkbox.nextSibling);
	});
}

customforms_checkbox();
// document.addEventListener('DOMContentLoaded', () => {
// 	customforms_checkbox();
// })

// var mobile = require('is-mobile');

function dropDownImage(image, el) {
	const optionImageURL = image.getAttribute('data-image');
	if (optionImageURL) {
		// console.log(optionImageURL);
		// Create <img> element for the image
		const optionImage = document.createElement('img');
		optionImage.src = optionImageURL;
		optionImage.alt = image.textContent; // Set alt text to option text
		el.appendChild(optionImage);
		// console.log(optionImageURL);
	}
}

function customforms_select() {
	console.log('forms');

	// if (!isMobile()) {
	const selects = document.querySelectorAll('select');
	selects.forEach((select) => {
		// add class to the select
		select.classList.add('dropdown-select');

		// create custom dropdown wrapper
		const dropdownParent = document.createElement('div');
		// dropdownParent.className = 'custom-dropdown ' + select.className;
		dropdownParent.className = 'custom-dropdown ';

		// get data from select field
		const options = select.querySelectorAll('option');

		// custom dropdown text
		const customDropdownText = document.createElement('div');
		customDropdownText.className = 'custom-dropdown-text';
		dropdownParent.appendChild(customDropdownText);
		customDropdownText.textContent = options[0].textContent;

		// Set the selected value in the new custom dropdown
		const selectedOption = select.querySelector('option:checked');
		if (selectedOption) {
			customDropdownText.textContent = selectedOption.textContent;
		}

		// wrap the select inside a custom dropdown
		// select.parentNode.insertBefore(dropdownParent, select);
		// dropdownParent.appendChild(select);
		select.insertAdjacentElement('afterend', dropdownParent);

		// custom dropdown
		const dropdown = document.createElement('ul');
		dropdown.className = 'dropdown';
		dropdownParent.append(dropdown);

		// custom dropdown arrow
		const customArrow = document.createElement('div');
		customArrow.className = 'custom-arrow';
		customArrow.innerHTML =
			'<svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.36603 10.5C6.98112 11.1667 6.01887 11.1667 5.63397 10.5L0.870835 2.25C0.485935 1.58333 0.967061 0.750001 1.73686 0.750001L11.2631 0.750002C12.0329 0.750002 12.5141 1.58334 12.1292 2.25L7.36603 10.5Z" fill="white"/></svg>';
		dropdownParent.appendChild(customArrow);

		options.forEach((option, index) => {
			// create <li> list
			const listItem = document.createElement('li');
			dropdown.appendChild(listItem);

			// set values of each item list from <option>
			listItem.textContent = option.textContent;
			listItem.setAttribute('data-value', option.value);

			// Add image to custom dropdown <li>, data url grabbed from data-image=""
			dropDownImage(option, listItem);

			listItem.addEventListener('click', () => {
				const value = listItem.getAttribute('data-value');
				customDropdownText.textContent = listItem.textContent; // change custom-dropdown-text value

				// Update the selected option value of the associated <select>
				select.value = value;

				dispatchChangeEvent(select);

				// add selected class to parent when clicking listitem but the first placeholder
				if (index > 0) {
					dropdownParent.classList.add('selected');
				} else {
					dropdownParent.classList.remove('selected');
				}
			});
		});

		dropdownParent.addEventListener('click', () => {
			dropdownParent.classList.toggle('active');
		});
	});
	// }
}

// Function to remove existing custom dropdowns
function removeCustomDropdowns() {
	const customDropdowns = document.querySelectorAll('.custom-dropdown');
	customDropdowns.forEach((customDropdown) => {
		customDropdown.parentNode.removeChild(customDropdown);
	});
}

// Function to handle FacetWP-loaded and FacetWP-refresh events
function handleFacetWPEvents() {
	removeCustomDropdowns(); // Remove existing custom dropdowns
	customforms_select(); // Reinitialize custom select
}

// Alternative function to dispatch a change event
function dispatchChangeEvent(element) {
	const event = document.createEvent('Event');
	event.initEvent('change', true, true);
	element.dispatchEvent(event);
}

customforms_select();
document.addEventListener('facetwp-loaded', handleFacetWPEvents);
document.addEventListener('facetwp-refresh', handleFacetWPEvents);
document.addEventListener('load', () => {
	// customforms_select();
});

// Global click event listener to close dropdowns when clicking outside
document.addEventListener('click', (event) => {
	const dropdowns = document.querySelectorAll('.custom-dropdown');
	dropdowns.forEach((dropdown) => {
		if (!dropdown.contains(event.target)) {
			dropdown.classList.remove('active');
		}
	});
});

function handleFileChange() {
	const customFileInputs = document.querySelectorAll(
		'.custom-file-input-wrapper',
	);

	customFileInputs.forEach((wrapper) => {
		const label = wrapper.querySelector('label');
		const input = wrapper.querySelector('input');

		wrapper.addEventListener('click', function () {
			console.log('click');
			input.click(); // trigger the input click if you click the wrapper
		});

		input.addEventListener('change', function () {
			if (this.files.length > 0) {
				const fileName = this.files[0].name;
				console.log(fileName);
				label.textContent = fileName;
			} else {
				console.error('No file selected');
			}
		});
	});
}
// document.addEventListener('DOMContentLoaded', handleFileChange);
handleFileChange();

// // Get the title of the page
function jobTitle() {
	if (window.location.pathname.includes('/vacancies')) {
		var pageTitle = document.title;
		var titleStripped = pageTitle.split(' – ')[0];
		document.querySelector('.job-title-hidden').value = 'Role: ' + titleStripped;
	}
}
jobTitle();
// document.addEventListener('DOMContentLoaded', hidden);
